const assets = {
    seaBnb: require('./seabnb.png'),
    jotter: require('./jotter.png'),
    v2_portfolio: require('./v2_portfolio.png'),
    v1_portfolio: require('./v1_portfolio.png'),
  }
export default assets